import { Popup } from '../../../design_system/components/Popup/Popup.jsx'
import { Icons } from '../../../design_system/components/Icons'
import { TEAM_TYPES } from './teamTypes'

const TeamTypeChip = ({ typeKey }) => {
    const type = TEAM_TYPES.find(t => t.key === typeKey)
    if (!type) return null
    return (
        <>
            <div className={`team-type-card__icon team-type-card__icon--${type.key}`}>
                <Icons name={type.iconName} size={16} />
            </div>
            <span className="body-s-bold">{type.label}</span>
        </>
    )
}

export const ConfirmChangePopup = ({ content, switching, isLoading, operations }) => {
    const { title, subtitle } = content
    const { from, to } = switching
    const { onConfirm, onCancel } = operations

    return (
        <Popup
            handleOnClosePopup={onCancel}
            maxWidth={424}
            show
            showFooterDivider={false}
            customContentStyle={{ padding: 0 }}
            primaryAction={{ label: 'Confirm change', onClick: onConfirm, isLoading }}
            secondaryAction={{ label: 'Cancel', onClick: onCancel }}
        >
            <div className="team-type-confirm">
                <div className="team-type-confirm__head">
                    <span className="body-l-bold">{title}</span>
                    {subtitle && (
                        <span className="body-l-semibold subtitle">{subtitle}</span>
                    )}
                </div>
                <div className="team-type-confirm__transition">
                    <div className="side">
                        <span className="support-m caption">From</span>
                        <TeamTypeChip typeKey={from} />
                    </div>
                    <Icons name="right-arrow" size={16} />
                    <div className="side">
                        <span className="support-m caption">To</span>
                        <TeamTypeChip typeKey={to} />
                    </div>
                </div>
            </div>
        </Popup>
    )
}
